interface ImproveButtonProps {
    title: string;
    description: string;
    icon: string;
}

interface Options {
    willPublish?: boolean;
    iconStyle?: string;
}

export function getImproveButtonProps(
    isTraining: boolean,
    loading: boolean,
    { willPublish = true, iconStyle = "far" }: Options = {}
): ImproveButtonProps {
    const defaultDescription = willPublish
        ? "Publish and retrain on new data."
        : "Retrain on new data.";

    if (isTraining) {
        return {
            title: "Retraining model...",
            description: "We'll email you when the new version is ready for review.",
            icon: "far fa-spinner fa-spin"
        };
    }

    if (loading) {
        return {
            title: "Gathering data...",
            description: defaultDescription,
            icon: "far fa-spinner fa-spin"
        };
    }

    return {
        title: "Improve Model",
        description: defaultDescription,
        icon: `${iconStyle} fa-sparkles`
    };
}
